"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemeAndPayment = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = tslib_1.__importDefault(require("@material-ui/core/Box"));
var index_1 = require("../../../index");
function SchemeAndPayment() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u4ED8\u6B3E\u65B9\u5F0F"),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [
                {
                    text: "无保存的付款方式",
                    des: "保存您的付款方式以获得更便捷的支付体验",
                },
            ] },
            react_1.default.createElement(index_1.SettingPrimaryButton, { onClick: function (item) {
                    console.log(item);
                } }, "\u6DFB\u52A0\u4ED8\u6B3E\u65B9\u5F0F")),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.DefaultTitle, null, "\u4EA4\u6613\u8BB0\u5F55"),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.BorderTitleView, { text: react_1.default.createElement("span", null,
                "\"\u5582\uFF0C\u5582\uFF01\u60F3\u5151\u6362 Discord \u79D8\u94A5\u5417\uFF1F\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u79FB\u5165\u4E86\"",
                react_1.default.createElement(index_1.SettingLinkButton, { href: "https://www.baidu.com/" }, "\u60A8\u7684\u6E38\u620F\u5E93")) })));
}
exports.SchemeAndPayment = SchemeAndPayment;
//# sourceMappingURL=SchemeAndPayment.js.map